import IStateReducerInfo, { InitializationAction } from '../Core/IStateReducerInfo.js';
import CmsState from './CmsState.js';

export const StateKey: string = "OptiContentCloud";

export type CmsSetStateAction = {
    type: 'OptiContentCloud/SetState',
} & CmsState;

export type CmsStateActionType = InitializationAction | CmsSetStateAction;

export type ContentAppState = {
    OptiContentCloud?: CmsState
}

export type PartialAppState = ContentAppState & {
    [key: string]: any
}

export const CmsStateReducerInfo: IStateReducerInfo<CmsState, CmsStateActionType> = {
    stateKey: StateKey,

    reducer: (state: CmsState | undefined, action: CmsStateActionType) => {
        let newState: CmsState = {};
        let stateChange = false

        switch (action.type) {
            case "@@EPI/INIT":
                newState = loadInitialState();
                stateChange = true
                break;
            case "OptiContentCloud/SetState":
                const toMerge: Partial<CmsState> = {};
                cpyAttr<CmsState>("currentLanguage", action, toMerge);
                newState = { ...state, ...toMerge }
                storeState(newState);
                stateChange = true
                break;
        }

        return stateChange ? newState : { ...state }
    }
}

function cpyAttr<T>(key: keyof T, from: Partial<T>, to: Partial<T>) {
    if (from[key]) to[key] = from[key];
}

function loadInitialState(): CmsState {
    try {
        const lang = window.location.href.indexOf('/fi/') !== -1 || window.location.href.endsWith('/fi') ? 'fi' : 'en'
        return lang ? { currentLanguage: lang } : {}
        //const data =  localStorage.getItem(StateKey);
        // return data ? JSON.parse(data) : {};
    } catch (e) {
        // Ignored on purpose
    }
    return {};
}

function storeState(state: Readonly<CmsState>) {
    try {
        localStorage.setItem(StateKey, JSON.stringify(state));
    } catch (e) {
        // Ignored on purpose
    }
}

export default CmsStateReducerInfo;